import { toOrdinal } from '@amwager/util-ts';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'ordinals',
  standalone: true
})
export class OrdinalsPipe implements PipeTransform {

  transform(number: number): string {
    return toOrdinal(number);
  }

}
